import React from "react" 

const OrderHistory =() => {
    return(
    <div> OrderHistory  </div>
    )
};

export default OrderHistory ;